<template lang="html">
	<a
		ref="el"
		href="#"
		class="omapi-link-arrow-before omapi-wizard-back"
		:disabled="disabled"
		@click.prevent="$bus.$emit('onboardingPrevPage')"
	>
		Go Back
	</a>
</template>
<script lang="js">
export default {
	props : {
		disabled : Boolean,
	},
};
</script>
